<div class="dropdown-wrapper">
<ejs-dropdowntree 
#tankDropDownTree
#tankTreeWrapper
id='tankField' 
[placeholder]='watermark'
 [showCheckBox]='showCheckBox'
  [mode]='mode' 
 [treeSettings]='treeSettings'
  [fields]='treeFields'
  cssClass="e-outline"
  [allowFiltering]="true"
  (dataBound)="onDataBound()"
  [filterType]="filterType" 
  (filtering)="onFiltering($event)"
  (open)="onTankDropDownOpen()"
  (select)="onNodeSelect($event)"
  (input)="onInput($event)"
  [customTemplate]="customTemplateRef"
  [showClearButton]="false"
  [enabled]="!disabled && !loading">
</ejs-dropdowntree>
<button
  *ngIf="getEnabledSelectedCount() > 0"
  mat-icon-button
  type="button"
  (click)="onCustomClear()"
  class="custom-clear-button"
>
  <mat-icon>clear</mat-icon>
</button>
<!-- spinner overlay when control is loading options -->
<div *ngIf='loading' class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
<ng-template #tankDisplay let-data>
  <!-- <ng-container *ngIf="selectedLocationIds.length > 0"> -->
    {{ selectedTankIds.length }} item{{ selectedTankIds.length > 1 ? 's' : '' }} selected
  <!-- </ng-container> -->
</ng-template>
<ng-template #customTemplateRef let-data>
  <div class="custom-template-wrapper">
    <ng-container *ngIf="enabledSelectedCount > 0; else showPlaceholder">
      {{ enabledSelectedCount }} item{{ enabledSelectedCount > 1 ? 's' : '' }} selected
    </ng-container>
    <ng-template #showPlaceholder>
      <span class="location-placeholder">{{ watermark }}</span>
    </ng-template>
  </div>
</ng-template>
</div>

